import ScrollMagic from "ScrollMagic";
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default {
  init() {
    $(window).load(() => {
      iconReveal.init();
    });
    $(document).ready(() => {
      iconCarousel.init();
    });
  },
};

let iconReveal = {
  init: () => {
    let controller = new ScrollMagic.Controller();

    let animateElemTop = document.getElementsByClassName('service-icons__bg-top'),
        items = document.getElementsByClassName('service-icons__item'),
        duration = $('.service-icons').outerHeight();

    let scene = new ScrollMagic.Scene({
        duration: duration,
        offset: $('.service-icons').position().top - 300,
      })
      // .addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function(e) {
        $(animateElemTop).css("height", e.progress.toFixed(3) * 100 + '%');
      });


    for (var i = items.length - 1; i >= 0; i--) {
      let offset = i == 0 ? 0 : 100;
      new ScrollMagic.Scene({
          triggerElement: "." + items[i].className.split(' ')[1],
          offset: offset,
        })
        .setClassToggle(items[i], "active")
        .addTo(controller);
    }

    $(window).on('resize orientationchange', function() {
      scene.update();
    });
  },
}

let iconCarousel = {
  init: () => {
    $('.service-icons__items').slick({
      slidesToShow: 1,
      rows: 0,
      dots: true,
      responsive: [{
        breakpoint: 9999,
        settings: "unslick",
      }, {
        breakpoint: 640,
        settings: {
          arrows: false,
        },
      }, {
        breakpoint: 480,
        settings: {
          arrows: false,
        },
      }],
    });
    $(window).on('resize orientationchange', function() {
      $('.service-icons__items').slick('resize');
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/single-service.js